import { removeLastSlashes } from "./removeLastSlashes";

export const getClearPath = (pathname: string) => removeLastSlashes(pathname);
